import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import X from '../../images/icons/x.inline.svg';
import BowTie from '../../images/icons/bow-tie.inline.svg';
import Wave from '../../images/waves/home-top-wave.inline.svg';

import Wrapper from '../elements/wrapper';
import { TransitionMixin } from '../helpers';

const SizeGuideContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgb(0, 0, 0, 0.65);
    z-index: 5500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .size-modal-container {
        flex: 1 1 100%;
        background-color: #f74d33;
        justify-content: center;
        max-width: 750px;
        margin: 0 auto;

        .size-guide {
            position: relative;
            overflow: hidden;
            .title-container {
                padding: 30px 0;
                margin: 0 30px 30px;
                display: flex;
                align-items: center;
                padding-bottom: 30px;
                border-bottom: 1px solid #fff;
                position: relative;
                z-index: 10;

                h3 {
                    flex: 1;
                    color: #fff;
                    font-size: 2.4rem;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;
                    margin-bottom: 0px;
                }

                .close-btn {
                    position: relative;
                    top: 3px;
                    button {
                        background-color: transparent;
                        border: none;
                        line-height: 1;
                        ${TransitionMixin('.25s')}

                        svg {
                            stroke: #fff;
                            height: 30px;
                            width: 30px;
                        }

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }
            .sizes-container {
                padding: 0 30px 40px;
                display: flex;

                .inner-wrap {
                    max-width: 95%;
                    margin: 0 auto;
                }

                .col {
                    flex: 1;

                    h4 {
                        font-family: neue-kabel, sans-serif;
                        font-weight: 800;
                        color: #fff;
                        font-size: 1.5rem;
                        margin: 0 0 20px;
                    }

                    p {
                        color: #fff;
                        font-size: 0.9rem;
                        margin: 0;

                        &.title {
                            font-weight: bold;
                        }
                    }
                }
            }

            &.bow-ties {
                .small-svg {
                    margin-bottom: 15px;
                    svg {
                        max-width: 90px;
                    }

                    &.md {
                        svg {
                            max-width: 70px;
                        }
                    }
                    &.sm {
                        svg {
                            max-width: 50px;
                        }
                    }
                }
            }

            .bottom-wave-container {
                svg {
                    position: absolute;
                    bottom: 50px;
                    left: 0;
                }
            }
        }
    }
`;

const SizeGuide = ({ setIsSizeGuideOpen }) => {
    function handleSizeGuideClose() {
        setIsSizeGuideOpen(false);
    }
    return (
        <SizeGuideContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <div className="size-modal-container">
                <Wrapper className="bow-ties size-guide">
                    <div className="title-container">
                        <h3>Bow Ties</h3>
                        <div className="close-btn">
                            <button onClick={() => handleSizeGuideClose()}>
                                <X />
                            </button>
                        </div>
                    </div>
                    <div className="sizes-container">
                        <div className="col">
                            <div className="inner-wrap">
                                <h4>Adult</h4>
                                <div className="small-svg">
                                    <BowTie />
                                </div>
                                <p className="title">Self-tied style</p>
                                <p className="info">
                                    Adjustable for necks 14-18”
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="inner-wrap">
                                <h4>Kid Pre-Tied</h4>
                                <div className="small-svg md">
                                    <BowTie />
                                </div>
                                <p className="title">Ages 2 and over</p>
                                <p className="info">
                                    Adjustable velcro closure
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="inner-wrap">
                                <h4>Baby Pre-Tied</h4>
                                <div className="small-svg sm">
                                    <BowTie />
                                </div>
                                <p className="title">Ages 2 and under</p>
                                <p className="info">
                                    Adjustable for necks 14-18”
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-wave-container">
                        <Wave />
                    </div>
                </Wrapper>
            </div>
        </SizeGuideContainer>
    );
};

export default SizeGuide;
